import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { QuotaCleanerSelectors } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';

import type { FastCleanerLoadingModalProps } from './FastCleanerLoadingModal';

const sendRadar = (action: string) => {
    sendDwh({
        eventCategory: 'modal',
        action,
        dwh_enabled: true,
        dwh_enabled_fields: [['name', 'platform']],
        dwhData: {
            name: 'fast_clean_loading',
            platform: getPlatformInfo().join('_'),
            offer_source: QuotaCleanerSelectors.getEntryPoint(reduxStore.getState()) || 'none',
        },
    });
};

// close функцию брать из ответа render
export const renderFastCleanLoadingModal = (
    { onClose, onShow }: FastCleanerLoadingModalProps & { onClose?: () => void } = { onClose: () => {}, onShow: () => {} }
) => {
    const handleShow = () => {
        sendRadar('show');
        onShow?.();
    };

    const handleClose = () => {
        sendRadar('close');
        onClose?.();
    };

    return openPopupHelper({
        popupName: popupNames.FAST_CLEAN_LOADING_MODAL,
        data: {
            onShow: handleShow,
        },
        onClose: handleClose,
    })?.closeDialog;
};
